export default `
Division By Zero is made by:
Programming - Claes-Magnus Berg
Music - Dennis Lindfors

Thanks to Harry for bug reports, suggestions and playing.

Graphics by:
Szadi art (licensed)
Evgeniy Luch (licensed)
Juicy Games (licensed)
@motionspgfx
and various artists, such as Animuz, with public domain licenses.
`;
